import {mergeToHierarchy} from '#core/utils/config-utils.js';
import {buildIntentsFromConfig} from '#core/utils/intent-factory.js';
import {PROXY_SHOW_DEPOSIT} from '#core/utils/intent-types.js';

import {ApplicationConfig} from '#core/config/application-config.js';

import {Bonuses} from '#core/application/modules/bonuses/bonuses.js';
import {AbstractVisualFeature} from '#core/application/modules/visual-feature.js';

import {Account} from '../account.js';

import {accountPopoverFactory} from './account-popover.factory';

import PALETTE_SCHEMA from './account-popover.palette-schema.yaml';

class AccountPopoverFeature extends AbstractVisualFeature {
    get name() {
        return 'AccountPopover';
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    getVisualConfig(PALETTE) {
        return accountPopoverFactory(PALETTE);
    }

    beforeMojitoConfigBuild(mojitoConfig) {
        mergeToHierarchy(mojitoConfig, 'services.configurations', {
            AccountMenu: {
                content: {
                    showVoucher: Bonuses.showVouchersInMenu,
                    showBonus: Bonuses.showBonusesInMenu,
                    additionalLinks: {
                        links: buildIntentsFromConfig(ApplicationConfig.config.accountMenu),
                    },
                    deposit: {
                        hide: false,
                        intent: PROXY_SHOW_DEPOSIT,
                    },
                    logout: {
                        hide: false,
                    },
                },
            },
        });

        return super.beforeMojitoConfigBuild(mojitoConfig);
    }
}

export const AccountPopover = new AccountPopoverFeature(Account);
